import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-glow" />
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="https://res.cloudinary.com/gtoqqet4/image/upload/v1786193349/LOGO_mrgxxx.jpg"
                alt="NORIX"
                style={{ height: 60, width: 60, borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(139,92,246,0.4)', boxShadow: '0 0 16px rgba(139,92,246,0.3)' }}
              />
            </div>
            <p>Premium clothing for those who dare to stand out. Quality crafted, style defined.</p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61592453758906" target="_blank" rel="noopener noreferrer" className="social-btn" title="Facebook">📘</a>
              <a href="https://www.tiktok.com/@jafahim12" target="_blank" rel="noopener noreferrer" className="social-btn" title="TikTok">🎵</a>
              <a href="tel:01957690873" className="social-btn" title="Call Us">📞</a>
            </div>
          </div>

          {/* Shop */}
          <div className="footer-col">
            <h4>Shop</h4>
            <Link to="/products?category=T-Shirt">T-Shirts</Link>
            <Link to="/products?category=Hoodie">Hoodies</Link>
            <Link to="/products?category=Sweatshirt">Sweatshirts</Link>
            <Link to="/products?category=Bag">Bags</Link>
            <Link to="/products?category=Watch">Watches</Link>
            <Link to="/products?category=Moneybag">Moneybags</Link>
            <Link to="/products?category=Saree">Sarees</Link>
            <Link to="/products?category=Tops">Tops</Link>
            <Link to="/products?category=Three Piece">Three Piece</Link>
          </div>

          {/* Account */}
          <div className="footer-col">
            <h4>Account</h4>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
            <Link to="/orders">My Orders</Link>
            <Link to="/profile">Profile</Link>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact</h4>
            <p>📍 Dhaka, Bangladesh</p>
            <p>📞 <a href="tel:01957690873" style={{color: 'inherit', textDecoration: 'none'}}>01957-690873</a></p>
            <p>📘 <a href="https://www.facebook.com/profile.php?id=61592453758906" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>Facebook</a></p>
            <p>🎵 <a href="https://www.tiktok.com/@jafahim12" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>TikTok</a></p>
            <div className="footer-tags">
              <span>Delivery: 2-5 days</span>
              <span>Inside Dhaka: ৳80</span>
              <span>Outside Dhaka: ৳150</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} NORIX. All rights reserved.</p>
          <p>Made with ❤️ in Bangladesh By Chinmoy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
